import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'

import { externalApiKeyClient } from '@/api'

const BASE_QUERY_KEY = externalApiKeyClient.QUERY_KEY
export const useOtherDnvApiKeys = () => {
  const queryClient = useQueryClient()
  const { showSuccess } = useToast()

  const otherDnvApiKeysQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: externalApiKeyClient.getAll
  })

  const addExternalApiKeyMutation = useMutation({
    mutationFn: externalApiKeyClient.addNewApiKey,
    onSuccess: async () => {
      showSuccess('API Key successfully added')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  const updateExternalApiKeyMutation = useMutation({
    mutationFn: externalApiKeyClient.updateApiKey,
    onSuccess: async () => {
      showSuccess('API Key successfully updated')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    otherDnvApiKeys: otherDnvApiKeysQuery.data || [],
    isOtherDnvApiKeysLoading: otherDnvApiKeysQuery.isLoading,
    addExternalApiKey: addExternalApiKeyMutation.mutate,
    updateExternalApiKey: updateExternalApiKeyMutation.mutate
  }
}
